module.exports = __webpack_public_path__ + "c4ca6f61cb8a8965344938f6341cd7bf.pdf";